var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhiteSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 108,
    viewBox: "0 0 178 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3768 0H35.3768L19.8768 62.5C16.8767 86.5 31.3767 89 45.3768 92C71.3768 96 140.877 88.5 177.877 54C147.877 71 115.377 73 96.8768 73.5H58.3768C46.3768 74.5 47.2102 64.8333 48.8768 59.5L64.3768 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8767 68.5H58.3768C61.485 26.5 72.8767 20 80.3767 14C106.777 -3.2 139.043 2.16667 151.877 7L144.877 29C137.377 22.1667 114.877 18.5 96.8768 29C76.4769 45.4 85.0434 62.1667 91.8767 68.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3767 55.5C-15.1233 115 89.2767 97.2 122.877 90C65.3759 119.5 -38.015 113.5 14.3767 55.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.376 98.5L146.376 83C143.876 84.5 94.8759 102.5 94.8759 102.5C94.8759 102.5 128.709 101.448 143.376 98.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhiteSvg);
export default __webpack_public_path__ + "static/media/logo-white-svg.bbabe66d6b790cfe29b157a00bb59682.svg";
export { ForwardRef as ReactComponent };